'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactScroll = require('react-scroll');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _PlanScorecardCompanyLetter = require('./PlanScorecardCompanyLetter.css');

var _PlanScorecardCompanyLetter2 = _interopRequireDefault(_PlanScorecardCompanyLetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyLetter202302 = (_dec = (0, _reactCssModules2.default)(_PlanScorecardCompanyLetter2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyLetter202302, _Component);

  function CompanyLetter202302(props) {
    (0, _classCallCheck3.default)(this, CompanyLetter202302);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompanyLetter202302.__proto__ || (0, _getPrototypeOf2.default)(CompanyLetter202302)).call(this, props));

    _this.state = {
      differentPage: _this.props.differentPage || false,
      companyName: _this.props.letterConfig.companyName,
      companyPath: _this.props.letterConfig.companyPath,
      letterDate: _this.props.letterConfig.letterDate,
      addresseeSurname: _this.props.letterConfig.addresseeSurname,
      addressee: _this.props.letterConfig.addressee,
      aspirationalGoal: _this.props.letterConfig.aspirationalGoal,
      asOfDate: _this.props.letterConfig.asOfDate,
      defaultInvestmentName: _this.props.letterConfig.defaultInvestmentName,
      noFewEsgOptions: _this.props.letterConfig.noFewEsgOptions,
      planAssets: _this.props.letterConfig.planAssets
    };
    return _this;
  }

  (0, _createClass3.default)(CompanyLetter202302, [{
    key: 'render',
    value: function render() {
      //
      return _react2.default.createElement(
        'blockquote',
        { styleName: 'company-letter-blockquote' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.state.letterDate
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.state.addressee,
            _react2.default.createElement('br', null),
            this.state.companyName
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Re: ',
            this.state.companyName,
            ' employee retirement plan sustainability scorecard'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Dear ',
          this.state.addresseeSurname,
          ','
        ),
        _react2.default.createElement(
          'p',
          null,
          this.state.companyName,
          ' is known to be a leader on climate change, highlighted by ',
          this.state.aspirationalGoal,
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'However, the company retirement plan directly contradicts all of this hard work on our operations.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'I am writing to inform you about the release of ',
          _react2.default.createElement(
            'i',
            null,
            'As You Sow\u2019s'
          ),
          ' retirement plan sustainability scorecard for ',
          this.state.companyName,
          ', and would like to extend an offer to meet and discuss our work. Below is a brief overview of the scorecard. '
        ),
        _react2.default.createElement(
          'p',
          null,
          'The retirement plan sustainability scorecard is designed to empower the millions of U.S. employees holding trillions of dollars in retirement assets to invest their retirement savings sustainably. Many employees across the nation are unaware that their retirement plan savings are invested in climate change, prisons, weapons, and companies that score poorly on gender equality.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'We are using our ',
          _react2.default.createElement(
            _.Link,
            { to: _config2.default.links.aysinvest, title: 'Invest Your Values - As You Sow', xstrong: true },
            'expertise in mutual fund sustainability analysis'
          ),
          ' and our extensive database of ESG-screened companies to rate employers\u2019 retirement plan investment options across multiple environmental and social issues, including deforestation, climate, and gender equality.'
        ),
        this.state.differentPage ? _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              _.Link,
              { to: _config2.default.routes.plans + '/' + this.state.companyPath, title: this.state.companyName + ' retirement plan sustainability scorecard', xstrong: true },
              'The scorecard results for the ',
              this.state.companyName,
              ' retirement plan'
            ),
            ' demonstrates that the company is failing to address the material risks of climate change in its 401(k) plan.'
          )
        ) : _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              _reactScroll.Link,
              { to: 'scores', spy: true, title: this.state.companyName + ' retirement plan sustainability scorecard', smooth: true, offset: -50, duration: 500 },
              _react2.default.createElement(
                'span',
                { styleName: 'scroll-link' },
                'The scorecard results for the ',
                this.state.companyName,
                ' retirement plan'
              )
            ),
            ' demonstrates that the company is failing to address the material risks of climate change in its 401(k) plan.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Since 1992, ',
          _react2.default.createElement(
            'i',
            null,
            'As You Sow'
          ),
          ' has had great success helping companies to adopt beneficial policies and practices on a range of environmental, social, and governance issues. The time is ripe for ',
          this.state.companyName,
          ' to show its leadership by aligning its sustainability goals holistically across both operations and its retirement plan. We commend ',
          this.state.companyName,
          ' in its efforts to build a sustainable business for all stakeholders and the planet, including ambitious climate goals and implementing them with action.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'While the company has made significant efforts to address climate change across its operations, data from Department of Labor filings showing company retirement plan options and invested amounts suggest to investors that ',
          this.state.companyName,
          ' has failed to address the material risks of climate change in its 401(k) plan in alignment with the duty to select retirement plan investment options in the best interests of plan participants and beneficiaries.'
        ),
        _react2.default.createElement(
          'p',
          null,
          this.state.companyName,
          ' uses ',
          this.state.defaultInvestmentName,
          ' as the default investment option in the 401(k) plan, and offers ',
          this.state.noFewEsgOptions,
          ' sustainable climate-safe investment options. The result is that the majority of the ',
          this.state.planAssets,
          ' of employee retirement dollars invested in the plan, as of ',
          this.state.asOfDate,
          ', invested in funds that hold companies that create substantial climate risk.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Most employees assume the default option in their retirement plan is a safe choice. But if climate risk and other sustainability issues are not incorporated into the portfolio management by the fund manager, employees could be exposed to financial risks from unsustainable investments. Given the threat that climate change poses to workers\u2019 life savings, ',
          this.state.companyName,
          ' should demonstrate that it is safeguarding employee financial security over time by mitigating climate change-related financial and economic risks as part of a prudently constructed lineup of funds.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Failing to satisfy this basic duty could be a liability for ',
          this.state.companyName,
          ', creating reputational risk and making it more difficult to retain employees increasingly concerned about catastrophic climate impacts.'
        ),
        this.state.differentPage ? _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.state.companyName,
            '\'s retirement plan is rated Poor on multiple issue areas. The full results ',
            _react2.default.createElement(
              _.Link,
              { to: _config2.default.routes.plans + '/' + this.state.companyPath, title: this.state.companyName + ' retirement plan sustainability scorecard', xstrong: true },
              'can be found here.'
            )
          )
        ) : _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.state.companyName,
            '\'s retirement plan is rated Poor on multiple issue areas. The full results ',
            _react2.default.createElement(
              _reactScroll.Link,
              { to: 'scores', spy: true, title: this.state.companyName + ' retirement plan sustainability scorecard', smooth: true, offset: -50, duration: 500 },
              _react2.default.createElement(
                'span',
                { styleName: 'scroll-link' },
                'can be found here.'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          this.state.companyName,
          ' has the opportunity to become an industry leader and help shift billions of dollars away from climate destruction and into companies that define the new economic paradigm in a safe, just, and sustainable world. We would appreciate the opportunity to meet with you and show you the details of our scorecard.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Thank you for your time and consideration, and we look forward to hearing back from you.'
        ),
        _react2.default.createElement(_.AndrewBeharSignature, null)
      );
    }
  }]);
  return CompanyLetter202302;
}(_react.Component), _class2.propTypes = {
  letterConfig: _react.PropTypes.object.isRequired,
  differentPage: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = CompanyLetter202302;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardCompanyLetter/CompanyLetter202302.js
// module id = 1401
// module chunks = 0